var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 60,
    viewBox: "0 0 94 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H94V60H0Z",
    transform: "translate(164 226)",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_project_-_merchants",
    "data-name": "new project - merchants",
    transform: "translate(-164 -226)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32364",
    "data-name": "Group 32364",
    transform: "translate(164.201 226.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34539",
    "data-name": "Path 34539",
    d: "M29.918,12.847V50.974h28.99V46.782h-25.3V12.848Z",
    transform: "translate(0 -0.099)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34540",
    "data-name": "Path 34540",
    d: "M36.338,8.01V44.615H63.81V15.33H56.455V8.01Z",
    transform: "translate(-0.131)",
    fill: "#5048bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34541",
    "data-name": "Path 34541",
    d: "M59.2,13.055h5.043L59.2,8.01Z",
    transform: "translate(-0.598 0)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34542",
    "data-name": "Path 34542",
    d: "M44.162,26.791v2.5h4.522v4.521h2.493V29.294H55.7v-2.5H51.177V22.269H48.684v4.522Z",
    transform: "translate(-0.291 -0.291)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProject);
export default __webpack_public_path__ + "static/media/new_project.6b38965d61315aaa85f29b985a65b014.svg";
export { ForwardRef as ReactComponent };